import { loader } from 'graphql.macro'

export default async function wastepayRefundTransaction ({ dataLoaders, variables }) {
  const schema = loader('./wastepayRefundTransaction.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: variables
  })
  return response.wastepayRefundTransaction
}
